<div class="welcome">
  <div class="welcome__container">
    <div class="welcome__container__logo">
      <img src="assets/images/logo-bxl.png" alt="logo" />
    </div>

    <div class="welcome__container__text">
      <h1 class="welcome__container__text-title">
        {{ "app_inforius" | translate }}
      </h1>

      <div class="row">
        <div class="col-12 text-center">
          <h1>{{ "errorPage.404.title" | translate }}</h1>
          <p>{{ "errorPage.404.content" | translate }}</p>
        </div>
        <div class="col-12 cta text-center">
          <a class="btn btn-primary" routerLink="/home">
            <em class="pi pi-home"></em>
            <span> {{ "errorPage.cta.backtoHome" | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
